module.exports = __webpack_public_path__ + "fonts/MPLUS1p-Regular.bfab3ff3.ttf";